import { AddOnType, StudentPaymentData } from '../types';

export const paymentData = [
  {
    admissionId: '1234',
    class: 'First',
    section: 'A',
    name: 'Akash Sharma',
    month: 'March',
    year: '2025',
    feesStatus: 'paid',
    feesReciept: ['https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'],
  },
  {
    admissionId: '1235',
    class: 'Second',
    section: 'B',
    name: 'Riya Verma',
    month: 'April',
    year: '2025',
    feesStatus: 'unpaid',
    feesReciept: [],
  },
  {
    admissionId: '1236',
    class: 'Third',
    section: 'A',
    name: 'Aditya Kumar',
    month: 'May',
    year: '2025',
    feesStatus: 'paid',
    feesReciept: ['https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'],
  },
  {
    admissionId: '1237',
    class: 'Fourth',
    section: 'C',
    name: 'Sneha Singh',
    month: 'March',
    year: '2025',
    feesStatus: 'paid',
    feesReciept: ['https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'],
  },
  {
    admissionId: '1238',
    class: 'Fifth',
    section: 'B',
    name: 'Yash Patel',
    month: 'February',
    year: '2025',
    feesStatus: 'unpaid',
    feesReciept: [],
  },
];

export const paymentDataForStudent: StudentPaymentData = {
  admissionId: '1234',
  class: 'First',
  section: 'A',
  name: 'Akash Sharma',
  motherName: 'Ganga Devi Sharma',
  fatherName: 'Jai Kumar Sharma',
  classRollNo: '1',
  contactNo: '9821496057',
  email: 'xyz@gmail.com',
  feesDetails: [
    { month: 'April', year: '2025', feesStatus: 'paid', feesReciept: ['https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'] },
    {
      month: 'May',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'June',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'July',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'August',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'September',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'October',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'November',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'December',
      year: '2025',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'January',
      year: '2026',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'February',
      year: '2026',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
    {
      month: 'March',
      year: '2026',
      feesStatus: 'unpaid',
      feesReciept: [],
    },
  ],
};

export enum FeesStatus {
  PAID = 'paid',
  UNPAID = 'unpaid',
  INPROCESS = 'inprocess',
}
export enum PaymentMethodEnum {
  ONLINE = 'online',
  CASH = 'cash',
}
export const header = ['Admission ID', 'Name', 'class', 'Month-Year', 'Fees Status', 'Reciept'];

export const studentPaymentListHeader = ['Month-Year', 'Fees Status', 'Reciept'];

export const emptyAddOns: AddOnType = {
  title: '',
  amount: '',
};
